import type { IOrganizationFinancialPositionBuffers } from './OrganizationFinancialPositionBuffers.interface';

export default class OrganizationFinancialPositionBuffers
  implements IOrganizationFinancialPositionBuffers {
  income: {
    rentalIncomeShading: { af: number, hl: number },
    totalIncomeShading: { af: number, hl: number },
    isPrimary: { af: boolean, hl: boolean }
  };

  existingRepayment: {
    multiplier: { af: number, hl: number },
    buffer: { af: number, hl: number },
    isPrimary: { af: boolean, hl: boolean }
  };

  proposedRepayment: {
    floorRate: { af: number, hl: number },
    buffer: { af: number, hl: number },
    isPrimary: { af: boolean, hl: boolean }
  };

  creditCardRate: {
    af: number,
    hl: number
  };

  overdraftRate: {
    af: number,
    hl: number
  };

  compareWithHem: {
    af: boolean,
    hl: boolean
  };

  hasPrimaryIncomeBufferAF() {
    return !this?.income?.isPrimary?.af;
  }

  hasPrimaryIncomeBufferHL() {
    return !this?.income?.isPrimary?.hl;
  }

  hasPrimaryExistingRepaymentBufferAF() {
    return !this?.existingRepayment?.isPrimary?.af;
  }

  hasPrimaryExistingRepaymentBufferHL() {
    return !this?.existingRepayment?.isPrimary?.hl;
  }

  hasPrimaryProposedRepaymentBufferAF() {
    return !this?.proposedRepayment?.isPrimary?.af;
  }

  hasPrimaryProposedRepaymentBufferHL() {
    return !this?.proposedRepayment?.isPrimary?.hl;
  }

  static build = (data: IOrganizationFinancialPositionBuffers) =>
    new OrganizationFinancialPositionBuffers(data);

  static blank = () => new OrganizationFinancialPositionBuffers();

  /**
   * Constructor
   * @param {IOrganizationFinancialPositionBuffers} data
   */
  constructor(data?: IOrganizationFinancialPositionBuffers) {
    this.income = {
      rentalIncomeShading: {
        af: parseFloat(data?.income?.rentalIncomeShading?.af || 0),
        hl: parseFloat(data?.income?.rentalIncomeShading?.hl || 0)
      },
      totalIncomeShading: {
        af: parseFloat(data?.income?.totalIncomeShading?.af || 0),
        hl: parseFloat(data?.income?.totalIncomeShading?.hl || 0)
      },
      isPrimary: {
        af: data?.income?.isPrimary?.af === true,
        hl: data?.income?.isPrimary?.hl === true
      }
    };
    this.existingRepayment = {
      multiplier: {
        af: parseFloat(data?.existingRepayment?.multiplier?.af || 0),
        hl: parseFloat(data?.existingRepayment?.multiplier?.hl || 0)
      },
      buffer: {
        af: parseFloat(data?.existingRepayment?.buffer?.af || 0),
        hl: parseFloat(data?.existingRepayment?.buffer?.hl || 0)
      },
      isPrimary: {
        af: data?.existingRepayment?.isPrimary?.af === true,
        hl: data?.existingRepayment?.isPrimary?.hl === true
      }
    };
    this.proposedRepayment = {
      floorRate: {
        af: parseFloat(data?.proposedRepayment?.floorRate?.af || 0),
        hl: parseFloat(data?.proposedRepayment?.floorRate?.hl || 0)
      },
      buffer: {
        af: parseFloat(data?.proposedRepayment?.buffer?.af || 0),
        hl: parseFloat(data?.proposedRepayment?.buffer?.hl || 0)
      },
      isPrimary: {
        af: data?.proposedRepayment?.isPrimary?.af === true,
        hl: data?.proposedRepayment?.isPrimary?.hl === true
      }
    };
    this.creditCardRate = {
      af: parseFloat(data?.creditCardRate?.af || 0),
      hl: parseFloat(data?.creditCardRate?.hl || 0)
    };
    this.overdraftRate = {
      af: parseFloat(data?.overdraftRate?.af || 0),
      hl: parseFloat(data?.overdraftRate?.hl || 0)
    };
    this.compareWithHem = {
      af: data?.compareWithHem?.af === true,
      hl: data?.compareWithHem?.hl === true
    };
  }
}
